/* hx-results — the before and after cards.
   1. Read more: a quote clamps to a few lines (CSS --clamp); when it runs past
      the clamp a Read more button appears under it and opens the card.
   2. The rail scrolls on its own, slowly, in whole pixels (Safari rounds a
      fractional scrollLeft away). It pauses while someone touches, hovers or
      focuses it, resumes a moment after they let go, and loops without a
      jump by drawing the cards twice. Off under prefers-reduced-motion, at
      speed 0, or when every card already fits.
   Loaded by hx-results and hx-customers-grid; runs once however many load it. */
(function () {
  if (window.__hxResults) return;
  window.__hxResults = true;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function readMore(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-hx-clamp]'), function (q) {
      if (q.__hxClamp) return;
      q.__hxClamp = true;
      var card = q.closest('[data-hx-card]');
      if (!card || q.scrollHeight <= q.clientHeight + 1) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rmore';
      b.textContent = 'Read more';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = card.classList.toggle('open');
        b.textContent = open ? 'Read less' : 'Read more';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      q.insertAdjacentElement('afterend', b);
    });
  }

  function rail(el) {
    var speed = (parseFloat(el.getAttribute('data-speed')) || 0) * 0.3;
    var sec = el.closest('.sec') || el.parentElement;
    var nav = sec && sec.querySelector('.rail-nav');
    var cards = Array.prototype.filter.call(el.children, function (c) { return c.hasAttribute('data-hx-card'); });
    if (!cards.length) return;
    var fits = el.scrollWidth <= el.clientWidth + 8;
    if (fits) { if (nav) nav.hidden = true; return; }
    var gap = parseFloat(getComputedStyle(el).columnGap) || 0;
    var step = function () { return cards[0].getBoundingClientRect().width + gap; };
    var half = function () { return 0; };
    var paused = true, resumeAt = 0, pos = 0;
    var hold = function () { paused = true; resumeAt = 0; };
    var release = function () { resumeAt = Date.now() + 2500; };

    if (speed > 0 && !reduce) {
      cards.forEach(function (c) {
        var k = c.cloneNode(true);
        k.setAttribute('aria-hidden', 'true');
        k.setAttribute('data-clone', '');
        el.appendChild(k);
      });
      el.classList.add('auto');
      half = function () { return el.children[cards.length].offsetLeft - cards[0].offsetLeft; };
      resumeAt = Date.now() + 1400;
      // The frame loop runs only while the rail is on screen and the tab is
      // visible: before 11 Oct 2026 it ran for the life of the page, on the
      // home page about two seconds of a throttled phone's main thread per
      // Lighthouse run, scrolling a rail nobody could see.
      var visible = true, running = false;
      var tick = function () {
        if (!visible || document.hidden) { running = false; return; }
        var h = half();
        if (!paused) {
          pos += speed;
          if (h > 0 && pos >= h) pos -= h;
          el.scrollLeft = Math.round(pos);
        } else if (resumeAt && Date.now() > resumeAt) {
          paused = false; resumeAt = 0; pos = el.scrollLeft;
        }
        requestAnimationFrame(tick);
      };
      var run = function () { if (running) return; running = true; requestAnimationFrame(tick); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; if (visible) run(); }, { rootMargin: '120px' }).observe(el);
      }
      document.addEventListener('visibilitychange', function () { if (!document.hidden && visible) run(); });
      run();
      ['pointerenter', 'pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (e) { el.addEventListener(e, hold, { passive: true }); });
      ['pointerleave', 'pointerup', 'touchend', 'touchcancel', 'focusout'].forEach(function (e) { el.addEventListener(e, release, { passive: true }); });
      el.addEventListener('scroll', function () {
        if (!paused) return;
        var h = half();
        if (h > 0 && el.scrollLeft >= h) el.scrollLeft -= h;
      }, { passive: true });
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        var b = e.target.closest('[data-rail-prev],[data-rail-next]');
        if (!b) return;
        hold();
        el.scrollBy({ left: b.hasAttribute('data-rail-prev') ? -step() : step(), behavior: reduce ? 'auto' : 'smooth' });
        release();
      });
    }
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hx-rail]'), rail);
    readMore(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
